module.exports = __webpack_public_path__ + "img/ep-I.8ea8251c.jpg";